export default __webpack_public_path__ + "static/linkdinImage-f9fab64f7f3bce396dd742a9e91bd1fe.webp";